import { HTTP } from "../../../../services/api-service.js";
import commonObj from "../../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;

const stockBalanceMultiStore = {
  namespaced: true,
  actions: {
    getAllCompStkBal({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stock/StkBalAllComp", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCatalogList({ commit, state }) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/Item/CatalogList")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default stockBalanceMultiStore;
